module.exports = __webpack_public_path__ + "img/vmc_aniv22_24Aug2021.18a23803.jpg";